import * as Switch from "@radix-ui/react-switch";
import { Lock } from "lucide-react";
import { cn } from "@/utils/stylesUtils";

export default function ToggleSwitch({ checked, onChange, id, disabled }) {
  return (
    <Switch.Root
      id={id}
      checked={checked}
      onCheckedChange={onChange}
      disabled={disabled}
      className={cn(
        "group relative inline-flex h-6 w-14 shrink-0 rounded-full px-1",
        "text-[12px] font-semibold text-white",
        "transition-colors duration-300 cursor-pointer flex items-center",
        "sm:h-7 sm:w-16 sm:text-[14px]",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        "data-[state=checked]:bg-[#1879EE]",
        "data-[state=unchecked]:bg-amber-400",
      )}
    >
      <span className="absolute left-1 hidden group-data-[state=checked]:inline text-white">
        ON
      </span>
      <span className="absolute right-1 hidden group-data-[state=unchecked]:inline text-amber-900">
        OFF
      </span>

      <Switch.Thumb
        className={cn(
          "absolute left-0.5 h-5 w-5 rounded-full bg-white shadow",
          "transition-transform duration-300",
          "data-[state=checked]:translate-x-8",
          "sm:h-6 sm:w-6 sm:data-[state=checked]:translate-x-9",
          "flex items-center justify-center",
        )}
      >
        {!checked && <Lock className="w-2.5 h-2.5 text-amber-500" />}
      </Switch.Thumb>
    </Switch.Root>
  );
}
